import { render, staticRenderFns } from "./passport-dialog.vue?vue&type=template&id=5bacd200&scoped=true"
import script from "./passport-dialog.vue?vue&type=script&lang=js"
export * from "./passport-dialog.vue?vue&type=script&lang=js"
import style0 from "./passport-dialog.vue?vue&type=style&index=0&id=5bacd200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bacd200",
  null
  
)

export default component.exports